<template>
  <div class="todo_list_container" v-if="listData.length > 0">
    <CardTitle :title="data.title" :badgeNum="badgeNum" skipPage="/task" />
    <img class="bg_img" :src="bgImg" />

    <div class="list_wrapper">
      <div v-for="item in listData" :key="item.taskId" class="list_item_wrapper" @click="skipHandle(item)">
        <div class="list_item">
          <div class="detail">
            <div class="title">
              <p class="title_text">{{ item.taskName }}</p>
            </div>
            <div class="time">
              <div>
                <span class="label">{{ getTaskTypeText(item.taskType) }}</span>
                <span class="home_card_status" :class="{ active: item.tagStatus === 200 }">
                  {{ getTagStatusText(item.tagStatus) }}
                </span>
              </div>
              <div v-if="!item.overdueStatus">
                <!-- 考试 批阅中不显示去考试-->
                <div v-if="item.taskType === 3 && item.tagStatus !== 300" class="task_card_detail">
                  <span>{{ $t('app_go_to_exam') }}</span>
                </div>
                <!-- 调查 -->
                <div v-if="item.taskType === 4" class="task_card_detail">
                  <span>{{ $t('app_go_to_participate') }}</span>
                </div>
                <!-- 培训-->
                <div v-if="item.taskType === 0" class="task_card_detail">
                  <span>{{ $t('app_course_learn') }}</span>
                </div>
                <div v-if="item.taskType === 8" class="task_card_detail">
                  <div v-if="item.tagStatus === 100 || item.tagStatus === 200">
                    {{ $t('go_practice') }}
                  </div>
                  <div v-else-if="item.timeStatus === 2" class="startBtn">
                    {{ $t('pc_person_view') }}
                  </div>
                  <div v-else-if="item.tagStatus === 300 && item.isRepeat === 0" class="startBtn">
                    {{ $t('pc_person_view') }}
                  </div>
                  <!-- 再练一次 -->
                  <div v-else>
                    {{ $t('go_practice_again') }}
                  </div>
                </div>
              </div>
              <div v-if="item.taskType === 9 && !item.countDownDuration">
                <div v-if="item.tagStatus === 200" class="task_card_detail">
                  {{ $t('app_go_to_participate') }}
                </div>
                <div v-else-if="item.tagStatus === 400 || item.tagStatus === 500" class="startBtn task_card_detail">
                  {{ $t('pc_person_view') }}
                </div>
              </div>
            </div>
            <div
              class="task_card_doing"
              v-if="item.taskType !== 8 && item.taskType !== 9 && item.tagStatus !== 100 && item.overdueStatus"
            >
              <!-- 距截止还剩 未开始和进行中才显示倒计时 -->
              <div
                v-if="
                  item.overdueStatus === 100 &&
                  item.countDownDuration &&
                  (item.tagStatus === 100 || item.tagStatus === 200)
                "
              >
                {{ $t('remain_time') }}
                <span class="task_card_time">{{ convertSeconds(item.countDownDuration) }}</span>
              </div>
              <!-- 已逾期 -->
              <div v-else-if="item.overdueStatus === 200" class="task_card_exceed_time">
                {{ $t('has_exceed_time') }}
              </div>
              <!-- 逾期完成 -->
              <div v-else-if="item.overdueStatus === 300" class="task_card_exceed_time">
                {{ $t('overdue_key') }}
              </div>
              <!-- CSS占位 -->
              <div></div>
              <!-- 考试 批阅中不显示去考试-->
              <div v-if="item.taskType === 3 && item.tagStatus !== 300" class="task_card_detail">
                <span>{{ $t('app_go_to_exam') }}</span>
              </div>
              <!-- 调查 -->
              <div v-if="item.taskType === 4" class="task_card_detail">
                <span>{{ $t('app_go_to_participate') }}</span>
              </div>
              <!-- 培训-->
              <div v-if="item.taskType === 0" class="task_card_detail">
                <span>{{ $t('app_course_learn') }}</span>
              </div>
            </div>
            <div
              class="task_card_doing"
              v-if="
                item.taskType === 8 &&
                (item.tagStatus === 100 || item.tagStatus === 200) &&
                item.countDownDuration &&
                item.overdueStatus
              "
            >
              <!-- 距截止还剩 未开始和进行中才显示倒计时 -->
              <div>
                {{ $t('remain_time') }}
                <span class="task_card_time">{{ convertSeconds(item.countDownDuration) }}</span>
              </div>
              <!-- 去练习 -->
              <div class="task_card_detail">
                <span>{{ $t('go_practice') }}</span>
              </div>
            </div>
            <div class="task_card_doing" v-if="item.taskType === 9 && item.countDownDuration">
              <!-- 距截止还剩 未开始和进行中才显示倒计时 -->
              <div>
                {{ $t('remain_time') }}
                <span class="task_card_time">{{ convertSeconds(item.countDownDuration) }}</span>
              </div>
              <!-- 去练习 -->
              <div v-if="item.tagStatus === 200" class="task_card_detail">
                {{ $t('app_go_to_participate') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useThemeImgs, useThemeColor } from '@/utils/theme'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const props = defineProps<{
  data: LmsDecorateModule
  badgeNum: number
}>()

const router = useRouter()

interface TItem {
  taskType: number
  taskId: string
}
const skipHandle = (item: TItem) => {
  switch (item.taskType) {
    case 3:
      router.push('/examInfo?examId=' + item.taskId)
      break
    case 4:
      // '调查'
      router.push('/surveyInfo?investigationId=' + item.taskId)
      break
    case 0:
      // '培训'
      router.push('/trainingDetail?id=' + item.taskId)
      break
    case 8:
      // '练习'
      router.push('/examPractiseInfo?practiseId=' + item.taskId)
      break
    case 9:
      router.push('/faceDetail?faceId=' + item.taskId)
      break
    default:
      return ''
  }
}

const listData = computed(() => {
  try {
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const { t } = useI18n()

const getTaskTypeText = (taskType: number) => {
  switch (taskType) {
    case 3:
      return t('app_task_exam')
    case 4:
      return t('app_task_survey')
    case 0:
      return t('app_task_train')
    case 8:
      return t('app_task_practice')
    case 9:
      // 面授
      return t('app_task_offline_train')
    default:
      return ''
  }
}
// 标签状态 100:未开始,200:进行中,300:批阅中,400:已完成,500:已过期,600:已结束
const getTagStatusText = (tagStatus: number) => {
  switch (tagStatus) {
    case 100:
      return t('app_not_started')
    case 200:
      return t('app_ongoing')
    case 300:
      return t('app_reviewing')
    case 400:
      return t('app_done')
    case 500:
      return t('app_expired')
    case 600:
      return t('app_ended')
    default:
      return ''
  }
}

const themeImgs = useThemeImgs()
const themeColor = useThemeColor()
const bgImg = computed(() => themeImgs.value.index_bg)

const convertSeconds = (duration: number) => {
  if (duration > 60) {
    const days = Math.floor(duration / (3600 * 24))
    const hours = Math.floor((duration % (3600 * 24)) / 3600)
    const minutes = Math.floor((duration % 3600) / 60)
    let result = ''
    if (days > 0) {
      result += days + t('day_h5')
    }
    if (hours > 0) {
      result += hours + t('app_class_room_hour')
    }
    if (minutes > 0) {
      result += minutes + t('app_my_training_time_min')
    }
    return result
  } else {
    return 1 + t('app_my_training_time_min')
  }
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.todo_list_container {
  margin: 12px 16px;
  padding: 0 12px;
  position: relative;
  background-color: @contentBackground;
  border-radius: 8px;
  overflow: hidden;

  .bg_img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 68px;
  }

  .list_wrapper {
    margin-top: 10px;

    .list_item_wrapper {
      padding: 13px 0;

      & + .list_item_wrapper {
        .border_1px_t;
      }
    }

    .list_item {
      display: flex;
      align-items: center;

      .detail {
        flex: 1;

        .title {
          display: flex;

          .label {
            flex: 0 0 auto;
            min-width: 38px;
            height: 18px;
            padding: 0 5px;
            background-color: v-bind(themeColor);
            .flex_center;
            font-size: 12px;
            color: @textWhite;
            border-radius: 4px;
          }

          .title_text {
            width: 0;
            flex: 1;
            color: @textPrimary;
            font-size: 16px;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            line-clamp: 3;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            max-height: 4em; /* 设置为行高的两倍 */
            word-break: break-all;
            overflow-wrap: break-word;
          }
        }

        .time {
          margin-top: 14px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }
      }

      .label {
        flex: 0 0 auto;
        color: @textInfo;
        color: v-bind(themeColor);
        border: 1px v-bind(themeColor) solid;
        padding: 3px 5px;
        border-radius: 4px;
        font-size: 12px;
        margin-right: 4px;

        &.active {
          color: v-bind(themeColor);
        }
      }

      .home_card_status {
        position: absolute;
        color: v-bind(themeColor);
        padding: 3px 5px;
        border-radius: 4px;
        font-size: 12px;
        z-index: 1;
        overflow: hidden;
      }

      .home_card_status::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: v-bind(themeColor);
        opacity: 0.1;
      }
    }

    .task_card_doing {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 400;
      padding-top: 8px;
      align-items: center;

      .task_card_time {
        color: v-bind(themeColor);
      }

      .task_card_exceed_time {
        color: #ef3837;
        font-size: 13px;
      }
    }
    .startBtn {
      color: #61666d !important;
      border: 1px solid #e1e1e1 !important;
      background: #fff !important;
    }
  }

  .task_card_detail {
    background-color: v-bind(themeColor);
    border-radius: 14px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    padding: 5px 11px;
    display: flex;
    align-items: center;
  }
}
</style>
